import { useState, useEffect, useLayoutEffect } from "react"
import BREAKPOINTS_PX from "../../BREAKPOINTS"

const convertPxToInt = pxValue => parseInt(pxValue.replace("px", ""))

const BREAKPOINTS = Object.fromEntries(
  Object.entries(BREAKPOINTS_PX).map(([key, value]) => [
    key,
    convertPxToInt(value),
  ])
)

export { BREAKPOINTS }

export function useBreakpoints() {
  const [isMounted, setIsMounted] = useState(false)
  useEffect(() => {
    setIsMounted(true)
  }, [])

  const isClient = typeof window === "object" && isMounted
  const getSizeClass = () => {
    const classes = document.body.className.split(" ")
    const sizeClasses = ["below-sm", "sm", "md", "desk", "xl", "fhd"]
    return classes.find(cls => sizeClasses.includes(cls))
  }
  const initialSizeClass = isClient ? getSizeClass() : null

  const getInitialScreenWidth = () => {
    switch (initialSizeClass) {
      case "below-sm":
        return 0
      case "sm":
        return BREAKPOINTS.sm
      case "md":
        return BREAKPOINTS.md
      case "desk":
        return BREAKPOINTS.desk
      case "xl":
        return BREAKPOINTS.xl
      case "fhd":
        return BREAKPOINTS.fhd
      default:
        return !isClient ? 0 : window.innerWidth
    }
  }

  const [screenWidth, setScreenWidth] = useState(getInitialScreenWidth())
  const [screenHeight, setScreenHeight] = useState(0)

  useLayoutEffect(() => {
    setScreenWidth(window.innerWidth)
    setScreenHeight(window.innerHeight)
    if (!isClient) return

    const handleResize = () => {
      setScreenWidth(window.innerWidth)
      setScreenHeight(window.innerHeight)
    }

    handleResize()

    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [isClient])
  const isMobile = screenWidth === 0 ? false : screenWidth < BREAKPOINTS.md
  const isTablet =
    screenWidth === 0
      ? false
      : screenWidth >= BREAKPOINTS.md && screenWidth <= BREAKPOINTS.desk
  const isRealTablet =
    screenWidth === 0
      ? false
      : screenWidth > BREAKPOINTS.sm && screenWidth <= BREAKPOINTS.desk
  const isDesktop = screenWidth === 0 ? false : screenWidth > BREAKPOINTS.desk
  const isXL = screenWidth === 0 ? false : screenWidth >= BREAKPOINTS.xl
  const is1750 = screenWidth === 0 ? false : screenWidth >= 1750

  return {
    isMobile,
    isTablet,
    isRealTablet,
    isDesktop,
    isXL,
    is1750,
    screenWidth,
    screenHeight,
  }
}
